import mapValues from 'lodash/mapValues';
import { replaceValues } from '@appcraft/form-sdk/rules';
import { hasOriginalData } from '../utils';

// Shared with the custom forms SDK and registration-service
export { replaceValues, computeMinMaxCount } from '@appcraft/form-sdk/rules';

export function hasExtension(filename, ext) {
  return filename.slice(filename.length - ext.length).toLowerCase() === ext;
}

export function isImage(filename) {
  if (!filename) return false;
  return hasExtension(filename, '.jpg') || hasExtension(filename, '.jpeg') || hasExtension(filename, '.png') || hasExtension(filename, '.gif');
}

export function isVideo(filename) {
  if (!filename) return false;
  return (
    hasExtension(filename, '.mp4') ||
    hasExtension(filename, '.m4v') ||
    hasExtension(filename, '.mkv') ||
    hasExtension(filename, '.avi') ||
    hasExtension(filename, '.mpeg')
  );
}

export function iconForFilename(filename) {
  if (!filename) return 'file';

  if (hasExtension(filename, '.pdf')) return 'file-pdf-o';
  if (hasExtension(filename, '.doc') || hasExtension(filename, '.docx')) return 'file-word-o';
  if (hasExtension(filename, '.xls') || hasExtension(filename, '.xlsx')) return 'file-excel-o';
  if (hasExtension(filename, '.ppt') || hasExtension(filename, '.pptx')) return 'file-powerpoint-o';
  if (isImage(filename)) return 'file-image-o';
  if (isVideo(filename)) return 'file-video-o';

  return 'file';
}

function roundDecimals(number) {
  return Math.round(number * 100) / 100;
}

export function sizeLabel(size) {
  const kbSize = size / 1024;
  if (kbSize < 900) return roundDecimals(kbSize) + ' ko';
  else return roundDecimals(kbSize / 1024) + ' Mo';
}

export function replaceObjectValues(obj, data) {
  return mapValues(obj, (v) => {
    if (typeof v === 'string') return replaceValues(v, data);
    return v;
  });
}

export function isFieldLocked(name, locked) {
  return locked && hasOriginalData(name);
}
